export type RandomIntegerSource = (maxExclusive: number) => number

type Uint32Source = () => number

const UINT32_RANGE = 0x1_0000_0000
const RANDOM_53_RANGE = 0x20_0000_0000_0000
const HIGH_21_MASK = 0x1f_ffff

function browserUint32(): number {
  if (typeof globalThis.crypto?.getRandomValues !== 'function') {
    throw new Error('Browser random source is unavailable')
  }

  const value = new Uint32Array(1)
  globalThis.crypto.getRandomValues(value)
  return value[0]!
}

export function createUnbiasedRandomInteger(nextUint32: Uint32Source): RandomIntegerSource {
  return (maxExclusive) => {
    if (!Number.isSafeInteger(maxExclusive) || maxExclusive < 1) {
      throw new RangeError('maxExclusive must be a positive safe integer')
    }

    const acceptanceLimit = Math.floor(RANDOM_53_RANGE / maxExclusive) * maxExclusive

    while (true) {
      const high = nextUint32()
      const low = nextUint32()
      if (!Number.isInteger(high) || high < 0 || high >= UINT32_RANGE
        || !Number.isInteger(low) || low < 0 || low >= UINT32_RANGE) {
        throw new RangeError('Uint32 source must return an integer between 0 and 2^32 - 1')
      }

      const candidate = (high & HIGH_21_MASK) * UINT32_RANGE + low
      if (candidate < acceptanceLimit) return candidate % maxExclusive
    }
  }
}

export const browserRandomInteger = createUnbiasedRandomInteger(browserUint32)
